import VBox from '@voly/ui-components/src/v2/VBox.jsx';
import VMaterialIcon from '@voly/ui-components/src/v2/icons/VMaterialIcon.jsx';
import VStackRow from '@voly/ui-components/src/v2/VStackRow.jsx';
import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { EStatus } from 'src/app/project/shared/enums/status.enum';
import { EStatusIcons } from 'src/app/project/shared/enums/status-icons.enum';

export type TStatusOption = {
  value: EStatus;
  labelKey: string;
  icon: (typeof EStatusIcons)['OPEN'];
};

export const OPTION_BY_STATUS: Record<EStatus, TStatusOption> = {
  [EStatus.OPEN]: {
    value: EStatus.OPEN,
    labelKey: 'open',
    icon: EStatusIcons.OPEN,
  },
  [EStatus.IN_PROGRESS]: {
    value: EStatus.IN_PROGRESS,
    labelKey: 'in_progress',
    icon: EStatusIcons.IN_PROGRESS,
  },
  [EStatus.TO_REVIEW]: {
    value: EStatus.TO_REVIEW,
    labelKey: 'to_review',
    icon: EStatusIcons.TO_REVIEW,
  },
  [EStatus.ONHOLD]: {
    value: EStatus.ONHOLD,
    labelKey: 'on_hold',
    icon: EStatusIcons.ONHOLD,
  },
  [EStatus.CLOSED]: {
    value: EStatus.CLOSED,
    labelKey: 'completed',
    icon: EStatusIcons.COMPLETED,
  },
  [EStatus.CANCELED]: {
    value: EStatus.CANCELED,
    labelKey: 'canceled',
    icon: EStatusIcons.CANCELLED,
  },
};

export const STATUS_OPTIONS = Object.values(OPTION_BY_STATUS);

const ICON_SIZE = 'sm';

export const findStatusOption = (value: string): TStatusOption | undefined =>
  STATUS_OPTIONS.find((option) => option.value === value);

const StatusLabel = ({ option }: { option: TStatusOption }): ReactElement => (
  <VStackRow gap={2}>
    <VBox
      as="span"
      display="inline-flex"
      alignItems="center"
      flexShrink={0}
      color="fg.muted"
      aria-hidden="true"
      data-testid="point-status-icon"
    >
      <VMaterialIcon name={option.icon} size={ICON_SIZE} />
    </VBox>
    {translate(option.labelKey)}
  </VStackRow>
);

export default StatusLabel;
